<div class="backup-devices-container">
    <div class="view-title">
        <h3>Storage Devices</h3>
        <button (click)="addDevice()" class="button mini">
            <mat-icon>add</mat-icon>
            Add
        </button>
    </div>
    <div class="device-table">
        <div *ngFor="let device of backupDevices" class="device-row">
            <div class="row-header">
                <span><mat-icon class="status-icon">storage</mat-icon>{{device.name}}</span>
                <div>
                    <button [disabled]="actionPending()" click-stop-propagation (click)="editDevice(device)" class="button outline mini">
                        <mat-icon>edit</mat-icon>
                        Edit
                    </button>
                    <button [disabled]="actionPending()" click-stop-propagation (click)="deleteDevice(device)" class="button outline mini">
                        <mat-icon>remove</mat-icon>
                        Delete
                    </button>
                </div>
            </div>
            <div class="main-data">
                <div class="column">
                    <span>ID</span>
                    <span>{{device.id}}</span>
                </div>
                <div class="column">
                    <span>Address</span>
                    <span>{{device.address}}</span>
                </div>
                <div class="column">
                    <span>Type</span>
                    <span>{{getDeviceTypeString(device.type)}}</span>
                </div>
                <div class="column">
                    <span>User</span>
                    <span>{{device.user ?? '-'}}</span>
                </div>
                <div class="column">
                    <span>Root folder</span>
                    <span>{{device.rootFolder}}</span>
                </div>
            </div>
        </div>
    </div>
</div>